<div class="p-modal-login">
  <div class="p-modal-login__title">
    <h2 class="c-text-l" [innerHTML]="'label.login' | staticMsg"></h2>
  </div>
  <div *ngIf="isNotLogin()">
    <p class="p-modal-login__text" [innerHTML]="'label.membershipStatus' | staticMsg"></p>
  </div>
  <div *ngIf="isNotLogin()" class="p-modal-login__item">
    <asw-input
      id="loginAnaMemberInput"
      [label]="'label.amcAccountNumber' | staticMsg"
      autocomplete="username"
      aria-invalid="false"
      [placeholder]="'placeholder.amcNumber' | staticMsg"
      [formControl]="idNameFormContrl"
      [alt]="'reader.amcAccountNumber' | staticMsg"
    ></asw-input>
    <div class="p-modal-login__item-link" [innerHTML]="'message.forgetAccountNumber' | staticMsg"></div>
  </div>

  <div *ngIf="!isNotLogin()" class="p-modal-login-mileage__item">
    <div class="c-form-element-confirm">
      <div class="c-form-element-confirm__label">
        <span class="c-form-element-confirm__label-text" [innerHTML]="'label.amcAccountNumber' | staticMsg"></span>
      </div>
      <div class="c-form-element-confirm__status">
        <span class="c-form-element-confirm__status-text">{{ labelIdName }}</span>
      </div>
    </div>
  </div>

  <div class="p-modal-login__item">
    <asw-input
      id="loginPasswordInput"
      [label]="'label.password' | staticMsg"
      type="password"
      autocomplete="current-password"
      aria-invalid="false"
      [placeholder]="'placeholder.password' | staticMsg"
      [formControl]="passwordFormContrl"
      [alt]="'reader.password' | staticMsg"
    ></asw-input>
    <div class="p-modal-login__item-link" [innerHTML]="'message.forgetPassword' | staticMsg"></div>

    <div *ngIf="isNotLogin()" class="p-modal-login__check">
      <asw-checkbox #checkboxComponent [label]="'label.keepLoginState' | staticMsg"> </asw-checkbox>
    </div>

    <div class="p-modal-login__btn">
      <asw-button
        id="login-component-button-login"
        [label]="'label.continueWithLogin' | staticMsg"
        (click$)="clickLogin($event)"
        throttleClick
      ></asw-button>
    </div>

    <div *ngIf="isSkipEnable && isNotLogin()" class="p-modal-login__btn">
      <asw-button
        type="secondary"
        id="login-component-button-login"
        [label]="'label.continueWithoutLogin' | staticMsg"
        (click$)="clickContinue($event)"
        throttleClick
      >
      </asw-button>
    </div>

    <div class="p-modal-login__join">
      <p class="c-text-m" [innerHTML]="'label.NotMember' | staticMsg"></p>
      <div class="p-modal-login__join-link" [innerHTML]="'label.AmcMileageClubAdmission' | staticMsg"></div>
    </div>
  </div>
</div>
